module.exports = __webpack_public_path__ + "img/antes_despues_85.d36d49f3.png";